import { render, staticRenderFns } from "./TweetVariations.vue?vue&type=template&id=1f5fb918&scoped=true&"
import script from "./TweetVariations.vue?vue&type=script&lang=js&"
export * from "./TweetVariations.vue?vue&type=script&lang=js&"
import style0 from "./TweetVariations.vue?vue&type=style&index=0&id=1f5fb918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5fb918",
  null
  
)

export default component.exports